/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SocialInteractionTargetViewCounterQueryVariables = Types.Exact<{
  urn: Types.Scalars['GlobalID']['input'];
}>;

export type SocialInteractionTargetViewCounterQuery = {
  __typename?: 'Query';
  viewer?: {
    __typename: 'Viewer';
    socialInteractionTarget?: {
      __typename: 'SocialInteractionTarget';
      urn: string;
      viewsCount?: number | null;
    } | null;
  } | null;
};

export const SocialInteractionTargetViewCounterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SocialInteractionTargetViewCounter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'urn' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GlobalID' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'socialInteractionTarget' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'urn' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'urn' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'urn' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'viewsCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SocialInteractionTargetViewCounterQuery,
  SocialInteractionTargetViewCounterQueryVariables
>;
